import React from 'react';
import TituloTexto from '../../../layout/titulo-texto';

const PagoAceptado = (props) => {
  const texto = 'Recibiras en tu email los datos de tu reserva junto con los comprobantes.';

  if (props.formaPago === 'deposito') {
    return (
      <TituloTexto titulo='Hemos realizado tu reserva con éxito' texto={texto} />
    );
  }
  return (
    <TituloTexto titulo='Hemos recibido tu pago con éxito' texto={texto} />
  );
};

export default PagoAceptado;
